// removed by extract-text-webpack-plugin
module.exports = {"root":"EventCard__root--18zgq","image":"EventCard__image--j2jTB","description":"EventCard__description--3QUqT","separator":"EventCard__separator--1HY6G","bounce":"EventCard__bounce--1qPxC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/EventCard/EventCard.css
// module id = ./src/components/Library/EventCard/EventCard.css
// module chunks = 2